module.exports = __webpack_public_path__ + "img/logo.802c3652.svg";